import React from 'react';

const UserBlue = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
      fill="#C6EBF9"
    />
    <rect
      width="20"
      height="20"
      transform="translate(6 6)"
      fill="white"
      fillOpacity="0.01"
      style={{ mixBlendMode: 'multiply' }}
    />
    <path
      d="M16 8.5C16.6181 8.5 17.2223 8.68328 17.7362 9.02666C18.2501 9.37004 18.6506 9.8581 18.8871 10.4291C19.1236 11.0001 19.1855 11.6285 19.065 12.2347C18.9444 12.8408 18.6467 13.3977 18.2097 13.8347C17.7727 14.2717 17.2158 14.5694 16.6097 14.69C16.0035 14.8105 15.3751 14.7486 14.8041 14.5121C14.2331 14.2756 13.745 13.8751 13.4017 13.3612C13.0583 12.8473 12.875 12.2431 12.875 11.625C12.875 10.7962 13.2042 10.0013 13.7903 9.41529C14.3763 8.82924 15.1712 8.5 16 8.5ZM16 7.25C15.1347 7.25 14.2888 7.50659 13.5694 7.98732C12.8499 8.46805 12.2892 9.15133 11.958 9.95076C11.6269 10.7502 11.5403 11.6299 11.7091 12.4785C11.8779 13.3272 12.2946 14.1067 12.9064 14.7186C13.5183 15.3304 14.2978 15.7471 15.1465 15.9159C15.9951 16.0847 16.8748 15.9981 17.6742 15.667C18.4737 15.3358 19.1569 14.7751 19.6377 14.0556C20.1184 13.3362 20.375 12.4903 20.375 11.625C20.375 10.4647 19.9141 9.35188 19.0936 8.53141C18.2731 7.71094 17.1603 7.25 16 7.25Z"
      fill="#0092C6"
    />
    <path
      d="M22.25 24.75H21V21.625C21 21.2146 20.9192 20.8083 20.7621 20.4291C20.6051 20.05 20.3749 19.7055 20.0847 19.4153C19.7945 19.1251 19.45 18.8949 19.0709 18.7379C18.6917 18.5808 18.2854 18.5 17.875 18.5H14.125C13.2962 18.5 12.5013 18.8292 11.9153 19.4153C11.3292 20.0013 11 20.7962 11 21.625V24.75H9.75V21.625C9.75 20.4647 10.2109 19.3519 11.0314 18.5314C11.8519 17.7109 12.9647 17.25 14.125 17.25H17.875C19.0353 17.25 20.1481 17.7109 20.9686 18.5314C21.7891 19.3519 22.25 20.4647 22.25 21.625V24.75Z"
      fill="#0092C6"
    />
  </svg>
);
export default UserBlue;
